export let homeEN = {
  common: {
    more: "Learn more",
  },
  bannerList: [
    {
      type: "image",
      duration: 7000,
      src: require("@/static/img/home/banner-robot.jpg"),
      title: "PILOTD Technology",
      subtitle:
        "Virtual Optimization & Synthetic Data for AI and Spatial Intelligent Agent",
    },
    {
      type: "image",
      duration: 7000,
      src: require("@/static/img/home/banner-physics.jpg"),
      title:
        "The World's Leading Fully Physical Sensor\nCore Modeling Technology",
      subtitle: "",
    },
    {
      type: "image",
      duration: 7000,
      src: require("@/static/img/home/banner-sim.jpg"),
      title: `PilotD Automotive：\n<span style="font-size: 2.1rem;">Supplier of Precise Simulation Systems for Automated Driving</span>`,
      subtitle:
        "Provide X-in-the-loop simulation-based verification and validation solutions to create a full-ecological digital twin in the simulation world",
    },
    {
      type: "video",
      duration: 28000,
      src: require("@/static/img/home/banner-intro.mp4"),
    },
  ],
  aboutUs: {
    title: "About Us",
    subtitle:
      "PilotD Technology, originated in Germany and founded in 2017, develops the cutting-edge  \"AI + Full-Physics World Model\" to deliver massive, high-precision synthetic data,  verification and validation solutions for intelligent agents.",
    video: require("@/static/img/home/about-us-video_en.mp4"),
    detail:
      "Aiming to eliminate critical bottlenecks in intelligent agent development and commercialization; starting from full-physical environmental perception sensor models to empower revolutionary simulation-based testing and development for intelligent agents.",
  },
  core: {
    title: "R&D for Various Intelligent Agents",
    subtitle:
      "Complex intelligent agent R&D based on high-validity simulation, providing customized intelligent solutions for diversified scenarios.",
    core: "Core Technologies",
    coreDetail: `Proprietary AI + Full-Physical Sensor Models can reach a virtual test <span class="text-highlight">validity level of approaching 95%</span>, which achieves near-lossless replication of real-world surface textures and optical characteristics of multi-band electromagnetic wave reflection.`,
    more: "Learn More",
    inteligence: "Intelligent Optimization Technology",
    list: [
      {
        title: "Automated Driving",
        detail:
          "Near-lossless replication of real driving scenarios and vehicle dynamics characteristics; closed-looping automated driving long-tail scenario validation.",
      },
      {
        title: "Embodied Intelligence",
        detail: `Combining multi-rigid-body structural dynamics based (tactile) robot "brain" optimization and validation.`,
      },
      {
        title: "Low-Altitude Economy",
        detail:
          "Swarm intelligence-based UAV mission planning and path guidance.",
      },
    ],
  },
  products: {
    title: "Our Product System",
    groups: [
      {
        title:
          "Simulation-based Various Intelligent Agents Testing\n& Validation Software System",
        subtitle:
          "Enabling scaled implementation and commercialization of automated driving vehicles, embodied intelligent robots, and UAVs for low-altitude economy",
        list: [
          {
            title:
              "Simulation-based Testing and Development Platform for Automated Driving-PDGaiA<sup>®</sup>7",
            subtitle:
              "Efficient and powerful functional safety oriented intelligent driving validation development tool",
          },
          {
            title: "PD Robotics Virtual Development & Validation Solution",
            subtitle: `Robot "brain" optimization and validation based on multi-rigid-body structural dynamics`,
          },
          {
            title:
              "PDUranus Virtual Optimization Platform for Intelligent UAVs",
            subtitle:
              "Swarm intelligence-based UAV mission planning and path guidance",
          },
        ],
      },
      {
        title: "Core Technologies Boosting Efficient Data-based Iteration",
        subtitle:
          "Empowering virtual optimization and synthetic data production: Faster, Higher, Stronger",
        list: [
          {
            title:
              "On Cloud Computing Platform for Precise Simulation - PD Cloud SiL",
            subtitle:
              "Massive multi-node parallel computing architecture on cloud; optimizing simulation speed",
          },
          {
            title: "PDRHea<sup>®</sup> PilotD Recursive Hierarchic Scenario Generator",
            subtitle:
              "Fully automated infinite scenario randomization and generation driven by AI, with extensive coverage",
          },
          {
            title: "PlenRay<sup>®</sup> Physical Ray Technology",
            subtitle:
              "Organic fusion of AI with physics-based environmental perception sensor models——providing Ultra-High simulation fidelity",
          },
        ],
      },
      {
        title: "Integrated Hardware/Software-in-the-Loop Testing System",
        subtitle:
          "Modular hardware enables flexible system combinations for vehicle component testing",
        list: [
          {
            title:
              "DiL Driver-in-the-Loop Solution to Restore Authentic Driving Sensation",
            subtitle: "Restore Authentic Driving Sensation",
            detail:
              "Coupled with dynamic models and proprietary motion washout algorithms, accurately restoring drivers' sensations during vehicle operation.",
          },
          {
            title: "Medusa Whole-Vehicle High-Validity Simulation Platform",
            subtitle: "Parallel computing for maximized efficiency",
            detail:
              "It enables concurrent testing of perception algorithms of all on-board sensors, perceptual data fusion algorithms and planning & control algorithms, significantly enhancing testing efficiency and accelerating algorithm iteration.",
          },
          {
            title: "Hercules Cost-Effective Hardware-in-the-Loop Platform",
            subtitle: "Maximum Results, Minimum Investment",
            detail:
              "Providing various real signals required by controllers; capturing and analyzing the controller's control signals, to complete close-loop simulation-based testing.",
          },
        ],
      },
    ],
  },
  cooperationPartner: {
    cooperationName: "Press Release",
    list01: {
      h1: `"Spotlight: PilotD Automotive Wins 'Emerging Breakthrough Award' and Joins Ningbo Metaverse Association as Council Member"`,
      h2: "Learn more >",
    },
    list02: {
      h1: `Good News: PilotD Automotive Certified as 'Technology-based SME'!`,
      h2: "Learn more >",
    },
    list03: {
      h1: "PilotD Automotive Named 'Top 10 Rising Stars in China's Tech Mobility Industry 2023'",
      h2: "Learn more >",
    },
    list04: {
      h1: `"The 3rd Automated Driving Simulation Technology Seminar Concluded Successfully"`,
      h2: "Learn more >",
    },
    list05: {
      h1: `"PilotD Automotive Honored as 'Outstanding Enterprise' at National Finals of the 12th China Innovation & Entrepreneurship Competition"`,
      h2: "Learn more >",
    },
    list06: {
      h1: `"Spotlight: PilotD Automotive Wins 'Emerging Breakthrough Award' and Joins Ningbo Metaverse Association as Council Member"`,
      h2: "Learn more >",
    },
    list07: {
      h1: `Good News: PilotD Automotive Certified as 'Technology-based SME'!`,
      h2: "Learn more >",
    },
    list08: {
      h1: "PilotD Automotive Named 'Top 10 Rising Stars in China's Tech Mobility Industry 2023'",
      h2: "Learn more >",
    },
    list09: {
      h1: `"The 3rd Automated Driving Simulation Technology Seminar Concluded Successfully"`,
      h2: "Learn more >",
    },
    list10: {
      h1: `"PilotD Automotive Honored as 'Outstanding Enterprise' at National Finals of the 12th China Innovation & Entrepreneurship Competition"`,
      h2: "Learn more >",
    },
    list11: {
      h1: `"PilotD Automotive Wins Shanghai Division Award at China Innovation & Entrepreneurship Competition"`,
      h2: "Learn more >",
    },
    list12: {
      h1: `"PilotD Automotive Wins Shanghai Division Award at China Innovation & Entrepreneurship Competition"`,
      h2: "Learn more >",
    },
    list13: {
      h1: `PilotD Automotive and STEP AI have reached a strategic partnership to enhance the efficiency of automated driving R&D through a strong alliance`,
      h2: "Learn more >",
    },
    list14: {
      h1: `PilotD Automotive and STEP AI have reached a strategic partnership to enhance the efficiency of automated driving R&D through a strong alliance`,
      h2: "Learn more >",
    },
    list15: {
      h1: `"Dr. -Ing. Peng Cao, Founder & CEO of PilotD Automotive: 2023 Review and 2024 Outlook"`,
      h2: "Learn more >",
    },
  },
};
export let homeCN = {
  common: {
    more: "了解更多",
  },
  bannerList: [
    {
      type: "image",
      duration: 7000,
      src: require("@/static/img/home/banner-robot.jpg"),
      title: "沛岱科技",
      subtitle: "AI和空间智能的智能体虚拟优化与合成数据",
    },
    {
      type: "image",
      duration: 7000,
      src: require("@/static/img/home/banner-physics.jpg"),
      title: "全球领先的全物理级传感器\n核心建模技术",
      subtitle: "",
    },
    {
      type: "image",
      duration: 7000,
      src: require("@/static/img/home/banner-sim.jpg"),
      title: "沛岱汽车\n自动驾驶精准在环仿真测试平台",
      subtitle: "提供在环仿真测试验证解决方案 打造仿真世界的全生态数字孪生",
    },
    {
      type: "video",
      duration: 28000,
      src: require("@/static/img/home/banner-intro.mp4"),
    },
  ],
  aboutUs: {
    title: "关于我们",
    subtitle:
      "沛岱科技，源自德国，成立于2017年，凭借全球领先的“AI+全物理模型World Model”核心建模技术，专注于为AI空间智能体提供海量、高精度的合成数据&训练及测试解决方案。",
    video: require("@/static/img/home/about-us-video_zh.mp4"),
    detail:
      "解决AI智能体落地的“卡脖子”问题为目标，以全物理级环境感知传感器模型为起点，助力AI智能体仿真测试与开发，为行业实现全新变革。",
  },
  core: {
    title: "全境智能研发",
    subtitle:
      "基于高逼真度仿真的复杂智能体研发，为多元场景提供定制化智能解决方案",
    core: "核心技术",
    coreDetail: `独创的AI+全物理的传感模型，虚拟测试<span class="text-highlight">还原率接近95%</span>，尽可能无损地还原真实场景表层纹理及其各频段电磁波光学反馈特性。`,
    more: "了解更多",
    inteligence: "智能优化技术",
    list: [
      {
        title: "智能驾驶",
        detail:
          "近无损地还原真实驾驶场景，及车辆动力学特性，完善智驾长尾场景闭环",
      },
      {
        title: "具身智能",
        detail: "结合基于多刚体结构力学（触觉）的机器人“大脑层” 技术优化与验证",
      },
      {
        title: "低空经济",
        detail: "基于群体智能的飞行器任务与路径规划技术",
      },
    ],
  },
  products: {
    title: "我们的产品体系",
    groups: [
      {
        title: "全境智能仿真测试验证软件体系",
        subtitle:
          "助力智能驾驶汽车、具身智能机器人、低空经济无人机的规模化应用",
        list: [
          {
            title: "PDGaiA<sup>®</sup> 自动驾驶精准在环仿真测试平台",
            subtitle: "高效且强大的智能驾驶功能安全验证开发工具",
          },
          {
            title: "PD 机器人虚拟开发验证解决方案",
            subtitle: "基于多刚体结构力学的机器人技术优化与测试",
          },
          {
            title: "PDUranus 智能无人低空载具虚拟优化平台",
            subtitle: "基于群体智能的飞行器任务与路径规划",
          },
        ],
      },
      {
        title: "核心技术助力高效数据迭代",
        subtitle: "助力虚拟优化和合成数据生产的 更“快”！更“高”！更“强”！",
        list: [
          {
            title: "On Cloud 精准仿真云计算平台",
            subtitle: "云端海量多节点并行计算架构，优化速度快",
          },
          {
            title: "PDRHea<sup>®</sup> 递归式分层场景生成器",
            subtitle: "AI随机无限生成场景，覆盖度高",
          },
          {
            title: "PlenRay<sup>®</sup> 物理射线技术",
            subtitle: "独创的AI+全物理的传感模型，仿真还原能力强",
          },
        ],
      },
      {
        title: "软硬件一体集成在环测试体系",
        subtitle: "模块化硬件能够灵活地组合用于车辆部件测试的系统",
        list: [
          {
            title: "PDDiL 驾驶员在环解决方案",
            subtitle: "还原真实的驾驶感受",
            detail:
              "配合动力学模型，通过自研运动洗出算法，真实准确地还原驾驶员在车辆驾驶过程中的感受",
          },
          {
            title: "Medusa 高置信度仿真平台",
            subtitle: "并行运算，提高效率",
            detail:
              "可同时测试所有传感器的感知融合算法以及规控算法，提高测试效率以加快算法迭代",
          },
          {
            title: "Hercules 高性价比硬件在环仿真平台",
            subtitle: "四两拨千斤，以小博大",
            detail:
              "提供控制器所需的各种真实信号， 采集与解析控制器控制信号，从而完成闭环仿真测试",
          },
        ],
      },
    ],
  },
  cooperationPartner: {
    cooperationName: "新闻资讯",
    list01: {
      h1: "沛岱汽车荣获「新锐突破奖」，当选宁波市元宇宙学会理事单位",
      h2: "了解更多 >",
    },
    list02: {
      h1: "沛岱汽车通过「科技型中小企业」认定！",
      h2: "了解更多 >",
    },
    list03: {
      h1: "沛岱汽车荣登「2023中国科技出行产业明日之星 TOP10」榜单",
      h2: "了解更多 >",
    },
    list04: {
      h1: "第三届自动驾驶仿真核心技术研讨会成功举办",
      h2: "了解更多 >",
    },
    list05: {
      h1: "沛岱汽车斩获第十二届中国创新创业大赛全国赛“优秀企业”荣誉",
      h2: "了解更多 >",
    },
    list06: {
      h1: "沛岱汽车荣获「新锐突破奖」，当选宁波市元宇宙学会理事单位",
      h2: "了解更多 >",
    },
    list07: {
      h1: "沛岱汽车通过「科技型中小企业」认定！",
      h2: "了解更多 >",
    },
    list08: {
      h1: "沛岱汽车荣登「2023中国科技出行产业明日之星 TOP10」榜单",
      h2: "了解更多 >",
    },
    list09: {
      h1: "第三届自动驾驶仿真核心技术研讨会成功举办",
      h2: "了解更多 >",
    },
    list10: {
      h1: "沛岱汽车斩获第十二届中国创新创业大赛全国赛“优秀企业”荣誉",
      h2: "了解更多 >",
    },
    list11: {
      h1: "沛岱汽车荣获中国创新创业大赛上海赛区优胜企业奖",
      h2: "了解更多 >",
    },
    list12: {
      h1: "沛岱汽车荣获中国创新创业大赛上海赛区优胜企业奖",
      h2: "了解更多 >",
    },
    list13: {
      h1: "沛岱汽车与足下科技达成战略合作，强强联合提升自动驾驶研发效能",
      h2: "了解更多 >",
    },
    list14: {
      h1: "沛岱汽车与足下科技达成战略合作，强强联合提升自动驾驶研发效能",
      h2: "了解更多 >",
    },
    list15: {
      h1: "沛岱汽车创始人、CEO曹鹏博士：2023总结与2024展望",
      h2: "了解更多 >",
    },
  },
};
